<!-- <div class="intro-section">
  <div class="intro-content">
    <div class="intro-text" [ngClass]="{ 'landing-style': isLanding }">
      <h1>{{ "landing-page-text-1" | translate }}</h1>
      <p>
        {{ "landing-page-text-2" | translate }}
      </p>
      <button class="button-form" (click)="redirectToForm()">
        {{ "go-to-form" | translate }}
      </button>
    </div>
    <div class="intro-image">
      <img src="../assets/icons/vehicles-frame.svg" alt="Vehículos" />
    </div>
  </div>
</div> -->

<div class="slider-container">
  <div class="top-bar">
    <button class="skip" (click)="skip()">Saltar</button>
  </div>

  <div
    class="slide"
    *ngFor="let slide of slides; let i = index"
    [class.active]="i === currentIndex"
  >
    <img [src]="slide.image" alt="Imagen {{ i + 1 }}" />
    <h3>{{ slide.title }}</h3>
    <p>{{ slide.description }}</p>
  </div>

  <div class="indicators">
    <span
      *ngFor="let slide of slides; let i = index"
      [class.active]="i === currentIndex"
    ></span>
  </div>
</div>

<div class="buttons">
  <button (click)="prev()" [disabled]="currentIndex === 0">Atrás</button>
  <button (click)="next()">
    {{ currentIndex === slides.length - 1 ? "Empezar" : "Siguiente" }}
  </button>
</div>
